import { VNode } from "omi";

import { ArrowLeftIcon } from "@/components/atoms/nw-icon/icons/arrowLeft";
import { ArrowRightIcon } from "@/components/atoms/nw-icon/icons/arrowRight";
import { BarChartIcon } from "@/components/atoms/nw-icon/icons/barChart";
import { CheckboxTickIcon } from "@/components/atoms/nw-icon/icons/checkboxTick.tsx";
import { CheckCircleOutlineIcon } from "@/components/atoms/nw-icon/icons/checkCircleOutline.tsx";
import { CheckHeartIcon } from "@/components/atoms/nw-icon/icons/checkHeart";
import { ChevronDownIcon } from "@/components/atoms/nw-icon/icons/chevronDown";
import { CloudIcon } from "@/components/atoms/nw-icon/icons/cloud";
import { CodeIcon } from "@/components/atoms/nw-icon/icons/code";
import { ContainerIcon } from "@/components/atoms/nw-icon/icons/container";
import { CopyIcon } from "@/components/atoms/nw-icon/icons/copy.tsx";
import { CrossIcon } from "@/components/atoms/nw-icon/icons/cross";
import { CurrencyDollarIcon } from "@/components/atoms/nw-icon/icons/currencyDollar";
import { DatabaseIcon } from "@/components/atoms/nw-icon/icons/database";
import { DataflowIcon } from "@/components/atoms/nw-icon/icons/dataflow";
import { DeleteIcon } from "@/components/atoms/nw-icon/icons/delete.tsx";
import { DocumentPDFIcon } from "@/components/atoms/nw-icon/icons/documents/pdf.tsx";
import { EditIcon } from "@/components/atoms/nw-icon/icons/edit";
import { FileIcon } from "@/components/atoms/nw-icon/icons/file";
import { FileHeartIcon } from "@/components/atoms/nw-icon/icons/fileHeart";
import { CountryKGIcon } from "@/components/atoms/nw-icon/icons/flags/kg";
import { CountryNGIcon } from "@/components/atoms/nw-icon/icons/flags/ng";
import { CountryPHIcon } from "@/components/atoms/nw-icon/icons/flags/ph";
import { CountryUSAIcon } from "@/components/atoms/nw-icon/icons/flags/usa";
import { CountryZAIcon } from "@/components/atoms/nw-icon/icons/flags/za";
import { FlipBackwardsIcon } from "@/components/atoms/nw-icon/icons/flipBackwards";
import { FlipBackwardsOrangeIcon } from "@/components/atoms/nw-icon/icons/flipBackwardsOrange";
import { GitMergeIcon } from "@/components/atoms/nw-icon/icons/gitMerge";
import { GoogleIcon } from "@/components/atoms/nw-icon/icons/google";
import { GreenCheckCircleIcon } from "@/components/atoms/nw-icon/icons/greenCheckCircle";
import { GridIcon } from "@/components/atoms/nw-icon/icons/grid.tsx";
import { HeartHandIcon } from "@/components/atoms/nw-icon/icons/heartHand";
import { HelpIcon } from "@/components/atoms/nw-icon/icons/help";
import { HomeLineIcon } from "@/components/atoms/nw-icon/icons/homeLine";
import { InstagramIcon } from "@/components/atoms/nw-icon/icons/instagram.tsx";
import { KeyIcon } from "@/components/atoms/nw-icon/icons/key";
import { LearningNextWorkIcon } from "@/components/atoms/nw-icon/icons/learningNextwork";
import { LetterAIcon } from "@/components/atoms/nw-icon/icons/letterA";
import { LinkIcon } from "@/components/atoms/nw-icon/icons/link";
import { LockIcon } from "@/components/atoms/nw-icon/icons/lock";
import { LoginIcon } from "@/components/atoms/nw-icon/icons/login";
import { MedalOneIcon } from "@/components/atoms/nw-icon/icons/medalOne.tsx";
import { MessageTextSquareIcon } from "@/components/atoms/nw-icon/icons/messageTextSqure.tsx";
import { NextWorkIcon } from "@/components/atoms/nw-icon/icons/nextwork";
import { NextWorkWhiteIcon } from "@/components/atoms/nw-icon/icons/nextworkWhite.tsx";
import { PinIcon } from "@/components/atoms/nw-icon/icons/pin";
import { PinActiveIcon } from "@/components/atoms/nw-icon/icons/pin-active";
import { RowsIcon } from "@/components/atoms/nw-icon/icons/rows";
import { SaveIcon } from "@/components/atoms/nw-icon/icons/save";
import { ServerIcon } from "@/components/atoms/nw-icon/icons/server";
import { SettingsCogIcon } from "@/components/atoms/nw-icon/icons/settingsCog";
import { SortArrowDownIcon } from "@/components/atoms/nw-icon/icons/sortArrowDown.tsx";
import { SortArrowUpIcon } from "@/components/atoms/nw-icon/icons/sortArrowUp.tsx";
import { StarIcon } from "@/components/atoms/nw-icon/icons/star";
import { TerminalCircleIcon } from "@/components/atoms/nw-icon/icons/terminalCircle";
import { TrashIcon } from "@/components/atoms/nw-icon/icons/trash";
import { TrophyIcon } from "@/components/atoms/nw-icon/icons/trophy";
import { UploadIcon } from "@/components/atoms/nw-icon/icons/upload";
import { WandIcon } from "@/components/atoms/nw-icon/icons/wand";

import { AdminIcon } from "./icons/admin";
import { AmazonIcon } from "./icons/amazon";
import { ArrowUpRightIcon } from "./icons/arrowUpRight";
import { BookmarkIcon } from "./icons/bookmark";
import { CalendarIcon } from "./icons/calendar";
import { CheckCircleIcon } from "./icons/checkCircle";
import { ChevronLeftIcon } from "./icons/chevronLeft";
import { CircleInfoFilledIcon } from "./icons/circleInfoFilled";
import { DotsVerticalIcon } from "./icons/dotsVertical";
import { FacebookIcon } from "./icons/facebook";
import { FilePlusIcon } from "./icons/filePlus";
import { FileQuestionIcon } from "./icons/fileQuestion";
import { FilterIcon } from "./icons/filter";
import { GithubIcon } from "./icons/github";
import { HourglassIcon } from "./icons/hourglass";
import { InfoCircleIcon } from "./icons/infoCircle";
import { KeyholeIcon } from "./icons/keyhole";
import { KeyYellowIcon } from "./icons/keyYellow";
import { LinkedInIcon } from "./icons/linkedin";
import { ListIcon } from "./icons/list";
import { LogoMarkDarkIcon } from "./icons/logoMarkDark";
import { LogoMarkLightIcon } from "./icons/logoMarkLight";
import { MarkdownIcon } from "./icons/markdown";
import { MessageQuestionCircleIcon } from "./icons/messageQuestionCircle";
import { MessageSquareIcon } from "./icons/messageSquare";
import { MinusCircleIcon } from "./icons/minus-circle";
import { ParagraphSpacingIcon } from "./icons/paragraphSpacing";
import { PencilIcon } from "./icons/pencil";
import { PlusIcon } from "./icons/plus";
import { PlusCircleIcon } from "./icons/plus-circle";
import { RefreshClockwiseIcon } from "./icons/refreshClockwise";
import { SearchIcon } from "./icons/search";
import { ShareIcon } from "./icons/share";
import { StickerSquareIcon } from "./icons/stickerSquare";
import { SwitchVerticalIcon } from "./icons/switchVertical";
import { ThumbsDownIcon } from "./icons/thumbs-down";
import { ThumbsUpIcon } from "./icons/thumbs-up";
import { TwitterIcon } from "./icons/twitter";
import { TypefaceIcon } from "./icons/typeface";
import { UploadCloudIcon } from "./icons/uploadCloud";
import { UserIcon } from "./icons/user";

type IconDefinition =
  | {
      [name in IconNameV1]: {
        src: string;
        alt: string;
      };
    }
  | {
      [name in IconNameV2]: VNode;
    };

export type IconProps = {
  width: number;
  height: number;
};

export type Countries = "usa" | "ng" | "za" | "kg" | "ph";
export type Documents = "document-pdf";
export type Socials = "linkedin" | "twitter" | "facebook" | "github" | "instagram";

export type IconNameV2 =
  | Countries
  | Documents
  | Socials
  | "bar-chart"
  | "cloud"
  | "lock"
  | "code"
  | "container"
  | "currency-dollar"
  | "database"
  | "dataflow"
  | "server"
  | "terminal-circle"
  | "wand"
  | "git-merge"
  | "login"
  | "file"
  | "key"
  | "google"
  | "arrow-right"
  | "arrow-left"
  | "help"
  | "save"
  | "star"
  | "edit"
  | "heart-hand"
  | "chevron-down"
  | "pin"
  | "pin-active"
  | "check-heart"
  | "nextwork"
  | "nextwork-white"
  | "home-line"
  | "file-heart"
  | "green-check-circle"
  | "flip-backwards"
  | "cross"
  | "admin"
  | "letter-a"
  | "file-question"
  | "trash"
  | "typeface"
  | "settings-cog"
  | "trophy"
  | "user"
  | "rows"
  | "learning-nextwork"
  | "amazon"
  | "plus"
  | "switch-vertical"
  | "calendar"
  | "list"
  | "minus-circle"
  | "plus-circle"
  | "message-question-circle"
  | "search"
  | "sort-arrow-down"
  | "sort-arrow-up"
  | "keyhole"
  | "key-yellow"
  | "upload-cloud"
  | "file-plus"
  | "dots-vertical"
  | "check-circle"
  | "share"
  | "chevron-left"
  | "checkbox-tick"
  | "link"
  | "upload"
  | "medal-one"
  | "pencil"
  | "sticker-square"
  | "paragraph-spacing"
  | "copy"
  | "message-text-square"
  | "message-square"
  | "grid"
  | "markdown"
  | "delete"
  | "arrow-up-right"
  | "filter"
  | "circle-info-filled"
  | "info-circle"
  | "check-circle-outline"
  | "hourglass"
  | "refresh-clockwise"
  | "logo-mark-light"
  | "logo-mark-dark"
  | "bookmark"
  | "thumbs-down"
  | "thumbs-up";

export type IconNameV1 =
  | "rocket"
  | "terminal-square"
  | "currency-dollar"
  | "tool"
  | "aws_lex"
  | "party-emoji"
  | "celebration"
  | "logout"
  | "message-smile-circle"
  | "alert-circle"
  | "img-file"
  | "tick"
  | "flip-backwards-orange"
  | "check-circle-outline-green"
  | "gray-check"
  | "download"
  | "eye";

export type IconName = IconNameV1 | IconNameV2;

export const IconDefV2: (width: number, height: number) => { [name in IconNameV2]: VNode } = (width, height) => ({
  "bar-chart": BarChartIcon({ width, height }),
  cloud: CloudIcon({ width, height }),
  code: CodeIcon({ width, height }),
  container: ContainerIcon({ width, height }),
  cross: CrossIcon({ width, height }),
  "currency-dollar": CurrencyDollarIcon({ width, height }),
  database: DatabaseIcon({ width, height }),
  dataflow: DataflowIcon({ width, height }),
  lock: LockIcon({ width, height }),
  server: ServerIcon({ width, height }),
  "terminal-circle": TerminalCircleIcon({ width, height }),
  wand: WandIcon({ width, height }),
  "git-merge": GitMergeIcon(),
  login: LoginIcon(),
  file: FileIcon(),
  key: KeyIcon(),
  google: GoogleIcon(),
  "arrow-left": ArrowLeftIcon({ width, height }),
  "arrow-right": ArrowRightIcon({ width, height }),
  usa: CountryUSAIcon(),
  ng: CountryNGIcon(),
  za: CountryZAIcon(),
  kg: CountryKGIcon(),
  ph: CountryPHIcon(),
  help: HelpIcon(),
  save: SaveIcon(),
  star: StarIcon({ width, height }),
  edit: EditIcon({ width, height }),
  "heart-hand": HeartHandIcon({ width, height }),
  "chevron-down": ChevronDownIcon({ width, height }),
  pin: PinIcon({ width, height }),
  "pin-active": PinActiveIcon({ width, height }),
  nextwork: NextWorkIcon({ width, height }),
  "nextwork-white": NextWorkWhiteIcon({ width, height }),
  "check-heart": CheckHeartIcon({ width, height }),
  "file-heart": FileHeartIcon({ width, height }),
  "home-line": HomeLineIcon({ width, height }),
  "green-check-circle": GreenCheckCircleIcon({ width, height }),
  "flip-backwards": FlipBackwardsIcon({ width, height }),
  "flip-backwards-orange": FlipBackwardsOrangeIcon({ width, height }),
  admin: AdminIcon({ width, height }),
  "letter-a": LetterAIcon({ width, height }),
  typeface: TypefaceIcon({ width, height }),
  "file-question": FileQuestionIcon({ width, height }),
  trash: TrashIcon({ width, height }),
  "settings-cog": SettingsCogIcon({ width, height }),
  trophy: TrophyIcon({ width, height }),
  user: UserIcon({ width, height }),
  rows: RowsIcon({ width, height }),
  "learning-nextwork": LearningNextWorkIcon({ width, height }),
  amazon: AmazonIcon({ width, height }),
  search: SearchIcon({ width, height }),
  plus: PlusIcon({ width, height }),
  "switch-vertical": SwitchVerticalIcon({ width, height }),
  calendar: CalendarIcon({ width, height }),
  list: ListIcon({ width, height }),
  "minus-circle": MinusCircleIcon({ width, height }),
  "plus-circle": PlusCircleIcon({ width, height }),
  "message-question-circle": MessageQuestionCircleIcon({ width, height }),
  "sort-arrow-down": SortArrowDownIcon({ width, height }),
  "sort-arrow-up": SortArrowUpIcon({ width, height }),
  keyhole: KeyholeIcon({ width, height }),
  "key-yellow": KeyYellowIcon({ width, height }),
  "file-plus": FilePlusIcon({ width, height }),
  "upload-cloud": UploadCloudIcon({ width, height }),
  "dots-vertical": DotsVerticalIcon({ width, height }),
  "check-circle": CheckCircleIcon({ width, height }),
  share: ShareIcon({ width, height }),
  "chevron-left": ChevronLeftIcon({ width, height }),
  "document-pdf": DocumentPDFIcon({ width, height }),
  "checkbox-tick": CheckboxTickIcon({ width, height }),
  link: LinkIcon({ width, height }),
  upload: UploadIcon({ width, height }),
  "medal-one": MedalOneIcon({ width, height }),
  pencil: PencilIcon({ width, height }),
  grid: GridIcon({ width, height }),
  "sticker-square": StickerSquareIcon({ width, height }),
  "paragraph-spacing": ParagraphSpacingIcon({ width, height }),
  "message-text-square": MessageTextSquareIcon({ width, height }),
  linkedin: LinkedInIcon({ width, height }),
  twitter: TwitterIcon({ width, height }),
  facebook: FacebookIcon({ width, height }),
  github: GithubIcon({ width, height }),
  instagram: InstagramIcon({ width, height }),
  copy: CopyIcon({ width, height }),
  "message-square": MessageSquareIcon({ width, height }),
  markdown: MarkdownIcon({ width, height }),
  delete: DeleteIcon({ width, height }),
  "arrow-up-right": ArrowUpRightIcon({ width, height }),
  filter: FilterIcon({ width, height }),
  "circle-info-filled": CircleInfoFilledIcon({ width, height }),
  "info-circle": InfoCircleIcon({ width, height }),
  "check-circle-outline": CheckCircleOutlineIcon({ width, height }),
  hourglass: HourglassIcon({ width, height }),
  "refresh-clockwise": RefreshClockwiseIcon({ width, height }),
  "logo-mark-light": LogoMarkLightIcon({ width, height }),
  "logo-mark-dark": LogoMarkDarkIcon({ width, height }),
  bookmark: BookmarkIcon({ width, height }),
  "thumbs-down": ThumbsDownIcon({ width, height }),
  "thumbs-up": ThumbsUpIcon({ width, height }),
});

export const IconDefV1: { [name in IconNameV1]: { src: string; alt: string } } = {
  rocket: {
    src: "/static/rocket.svg",
    alt: "Rocket icon",
  },
  // hourglass: {
  //   src: "/static/hourglass.svg",
  //   alt: "Hourglass icon",
  // },
  tool: {
    src: "/static/tool.svg",
    alt: "Tool icon",
  },
  "terminal-square": {
    src: "/static/terminal-square.svg",
    alt: "Terminal square icon",
  },
  "currency-dollar": {
    src: "/static/currency-dollar.svg",
    alt: "Dollar icon",
  },
  aws_lex: {
    src: "/static/aws_lex.png",
    alt: "Amazon Lex icon",
  },
  "party-emoji": {
    src: "/static/party-emoji.svg",
    alt: "Party emoji!",
  },
  celebration: {
    src: "/static/celebration.svg",
    alt: "Celebration fireworks!",
  },
  "alert-circle": {
    src: "/static/alert-circle.svg",
    alt: "Alert circle icon",
  },
  logout: {
    src: "/static/logout.svg",
    alt: "Logout icon",
  },
  download: {
    src: "/static/download.svg",
    alt: "Download icon",
  },
  eye: {
    src: "/static/eye.svg",
    alt: "Eye icon",
  },
  "message-smile-circle": {
    src: "/static/message-smile-circle.svg",
    alt: "Message bubble with smile icon",
  },
  "img-file": {
    src: "/static/img-file.svg",
    alt: "Image file icon",
  },
  tick: {
    src: "/static/tick.svg",
    alt: "Tick icon",
  },
  "check-circle-outline-green": {
    src: "/static/check-circle-outline-green.svg",
    alt: "Green circle with tick icon",
  },
  "flip-backwards-orange": {
    src: "/static/flip-backwards-orange.svg",
    alt: "Orange backwards arrow icon",
  },
  "gray-check": {
    src: "/static/gray-check.svg",
    alt: "Gray check icon",
  },
};

export const IconDef: IconDefinition = {
  ...IconDefV1,
  ...IconDefV2,
};
